/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from '../API';
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const listAllReportsUnderLeader = /* GraphQL */ `query ListAllReportsUnderLeader(
  $hierarchy_distance: Int
  $supervisor_login: String!
) {
  listAllReportsUnderLeader(
    hierarchy_distance: $hierarchy_distance
    supervisor_login: $supervisor_login
  ) {
    reports_under_leader {
      data {
        department_name_current
        emplid
        employee_assistant_employee_id
        employee_internal_email_address
        employee_name
        job_level_name
        job_title_name
        location_city_name
        location_state_name
        login_name
      }
    }
  }
}
` as GeneratedQuery<APITypes.ListAllReportsUnderLeaderQueryVariables, APITypes.ListAllReportsUnderLeaderQuery>;
export const listAnnouncements = /* GraphQL */ `query ListAnnouncements {
  listAnnouncements {
    announcement
    announcementCategory {
      id
      label
      labelType
    }
    announcementDate
    announcementLink
    applicationName {
      id
      label
      labelType
    }
    id
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    title
  }
}
` as GeneratedQuery<APITypes.ListAnnouncementsQueryVariables, APITypes.ListAnnouncementsQuery>;
export const listApplicationFavorites = /* GraphQL */ `query ListApplicationFavorites($userAlias: String) {
  listApplicationFavorites(userAlias: $userAlias) {
    applicationId
    id
    userAlias
  }
}
` as GeneratedQuery<APITypes.ListApplicationFavoritesQueryVariables, APITypes.ListApplicationFavoritesQuery>;
export const listApplications = /* GraphQL */ `query ListApplications {
  listApplications {
    applicationLink
    applicationName
    applicationOwnerId
    embeddingEnabled
    fullApplicationDescription
    glAccounts {
      id
      label
      labelType
    }
    hasNonProductionEnvironments
    id
    isFlagship
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    keyDimension {
      id
      label
      labelType
    }
    lastEnhanced {
      id
      label
      labelType
    }
    logoConfig {
      logoType
      s3Location {
        bucket
        contentType
        key
        region
      }
      selectedLogoName
      uploadedFileName
    }
    mcpPath
    nonProductionEnvironments {
      accessLevel {
        id
        label
        labelType
      }
      displayText
      id
      link
    }
    process {
      id
      label
      labelType
    }
    qChatConfig {
      agentUrl
      isEnabled
    }
    scenario {
      id
      label
      labelType
    }
    shortApplicationDescription
    timeGranularity {
      id
      label
      labelType
    }
    toolUI {
      id
      label
      labelType
    }
  }
}
` as GeneratedQuery<APITypes.ListApplicationsQueryVariables, APITypes.ListApplicationsQuery>;
export const listDogmaDetail = /* GraphQL */ `query ListDogmaDetail {
  listDogmaDetail {
    dogma_details {
      data {
        created_date
        manager_login_hierarchy_concat
        manager_name_hierarchy_concat
        resolved_date
        risk_best_practices
        risk_entity_type
        risk_entity_value
        risk_owner_login
        risk_owner_name
        risk_pipeline_name
        risk_rule_id
        risk_severity
        status
        team_name
      }
      metadata {
        last_updated_at
      }
    }
  }
}
` as GeneratedQuery<APITypes.ListDogmaDetailQueryVariables, APITypes.ListDogmaDetailQuery>;
export const listEmployeesByAliases = /* GraphQL */ `query ListEmployeesByAliases($login_aliases: [String]!) {
  listEmployeesByAliases(login_aliases: $login_aliases) {
    data {
      department_name_current
      emplid
      employee_assistant_employee_id
      employee_internal_email_address
      employee_name
      job_level_name
      job_title_name
      location_city_name
      location_state_name
      login_name
    }
  }
}
` as GeneratedQuery<APITypes.ListEmployeesByAliasesQueryVariables, APITypes.ListEmployeesByAliasesQuery>;
export const listEmployeesByNames = /* GraphQL */ `query ListEmployeesByNames($employee_names: [String]!, $records_per_name: Int) {
  listEmployeesByNames(
    employee_names: $employee_names
    records_per_name: $records_per_name
  ) {
    data {
      department_name_current
      emplid
      employee_assistant_employee_id
      employee_internal_email_address
      employee_name
      job_level_name
      job_title_name
      location_city_name
      location_state_name
      login_name
    }
  }
}
` as GeneratedQuery<APITypes.ListEmployeesByNamesQueryVariables, APITypes.ListEmployeesByNamesQuery>;
export const listExecutiveAssistants = /* GraphQL */ `query ListExecutiveAssistants($supervisor_login: String) {
  listExecutiveAssistants(supervisor_login: $supervisor_login) {
    data {
      department_name_current
      emplid
      employee_assistant_employee_id
      employee_internal_email_address
      employee_name
      job_level_name
      job_title_name
      location_city_name
      location_state_name
      login_name
    }
  }
}
` as GeneratedQuery<APITypes.ListExecutiveAssistantsQueryVariables, APITypes.ListExecutiveAssistantsQuery>;
export const listFeedback = /* GraphQL */ `query ListFeedback {
  listFeedback {
    applicationName {
      id
      label
      labelType
    }
    feedback
    feedbackType
    id
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    rating
  }
}
` as GeneratedQuery<APITypes.ListFeedbackQueryVariables, APITypes.ListFeedbackQuery>;
export const listFinanceCalendarEvents = /* GraphQL */ `query ListFinanceCalendarEvents {
  listFinanceCalendarEvents {
    dateTime
    description
    event
    eventId
    scenario
    source
  }
}
` as GeneratedQuery<APITypes.ListFinanceCalendarEventsQueryVariables, APITypes.ListFinanceCalendarEventsQuery>;
export const listGeneralContent = /* GraphQL */ `query ListGeneralContent {
  listGeneralContent {
    content
    id
    name
  }
}
` as GeneratedQuery<APITypes.ListGeneralContentQueryVariables, APITypes.ListGeneralContentQuery>;
export const listHomePageContent = /* GraphQL */ `query ListHomePageContent {
  listHomePageContent {
    applicationBanner {
      action {
        label
        url
      }
      bannerType
      content
      dismissible
      header
      isEnabled
    }
    contactsWidgetContacts {
      contactId
      groupName
      otherContacts {
        contactAlias
        contactName
      }
      primaryContact {
        contactAlias
        contactName
      }
      simLinks {
        name
        url
      }
      slackChannels {
        name
        url
      }
    }
    hasWelcomeContent
    id
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    welcomeContentDetails {
      description
      displayText
      id
      link
      pointOfContact
    }
    welcomeTitle
  }
}
` as GeneratedQuery<APITypes.ListHomePageContentQueryVariables, APITypes.ListHomePageContentQuery>;
export const listLabels = /* GraphQL */ `query ListLabels {
  listLabels {
    id
    label
    labelType
  }
}
` as GeneratedQuery<APITypes.ListLabelsQueryVariables, APITypes.ListLabelsQuery>;
export const listMappingColDetails = /* GraphQL */ `query ListMappingColDetails {
  listMappingColDetails {
    col_def {
      data
    }
  }
}
` as GeneratedQuery<APITypes.ListMappingColDetailsQueryVariables, APITypes.ListMappingColDetailsQuery>;
export const listMappingConfig = /* GraphQL */ `query ListMappingConfig {
  listMappingConfig {
    mapping_config {
      data {
        mapping_key
        mapping_name
        target_table
      }
    }
  }
}
` as GeneratedQuery<APITypes.ListMappingConfigQueryVariables, APITypes.ListMappingConfigQuery>;
export const listMappingDetails = /* GraphQL */ `query ListMappingDetails($table_name: String, $limit: Int, $offset: Int) {
  listMappingDetails(table_name: $table_name, limit: $limit, offset: $offset) {
    mapping_details {
      data
    }
    total_count
  }
}
` as GeneratedQuery<APITypes.ListMappingDetailsQueryVariables, APITypes.ListMappingDetailsQuery>;
export const listMappingValidationConfig = /* GraphQL */ `query ListMappingValidationConfig {
  listMappingValidationConfig {
    mapping_validation_config {
      data
    }
  }
}
` as GeneratedQuery<APITypes.ListMappingValidationConfigQueryVariables, APITypes.ListMappingValidationConfigQuery>;
export const listPolicyEngineDetail = /* GraphQL */ `query ListPolicyEngineDetail {
  listPolicyEngineDetail {
    policy_engine_details {
      data {
        create_date
        last_updated_at
        manager_login_hierarchy_concat
        manager_name_hierarchy_concat
        policy_class
        policy_type
        resolution_type
        resolved_date
        severity
        status
        team_name
        violation_entity_type
        violation_name
        violation_pretty_name
        violator_id
        violator_manager_login
        violator_manager_name
        violator_name
        violator_owner
        violator_owner_name
        violator_type
      }
      metadata {
        last_updated_at
      }
    }
  }
}
` as GeneratedQuery<APITypes.ListPolicyEngineDetailQueryVariables, APITypes.ListPolicyEngineDetailQuery>;
export const listSASDetail = /* GraphQL */ `query ListSASDetail {
  listSASDetail {
    sas_details {
      data {
        assignee_login
        assignee_name
        campaign_name
        has_recommendation
        is_blocked_campaign
        oldest_recommendation_age
        oldest_risk_age
        resource_name
        resource_type
        risk_status_at_eom
        snapshot_month
        supervisor_login_name_hierarchy
        supervisor_name_hierarchy
        team_name
      }
      metadata {
        last_updated_at
      }
    }
  }
}
` as GeneratedQuery<APITypes.ListSASDetailQueryVariables, APITypes.ListSASDetailQuery>;
export const listTeamPageContent = /* GraphQL */ `query ListTeamPageContent {
  listTeamPageContent {
    enableTeamInfoTabs
    id
    itemMetadata {
      createdBy
      createdTime
      isActive
      updatedBy
      updatedTime
    }
    sidePanelDetails {
      customSidePanelWidgets {
        contentType
        id
        isEnabled
        isExpandedByDefault
        richTextContent
        tableContent {
          displayName
          id
          link
          position
        }
        title
      }
      keyContacts {
        contentType
        isEnabled
        isExpandedByDefault
        richTextContent
        title
      }
      officeHours {
        contentType
        isEnabled
        isExpandedByDefault
        richTextContent
        title
      }
      supportLinks {
        contentType
        id
        isEnabled
        isExpandedByDefault
        richTextContent
        tableContent {
          displayName
          id
          link
          position
        }
        title
      }
    }
    teams {
      id
      teamIntroductionVideoUrl
      teamName
      teamOverView
      teamWelcomeDetails {
        description
        displayText
        id
        link
        pointOfContact
      }
    }
  }
}
` as GeneratedQuery<APITypes.ListTeamPageContentQueryVariables, APITypes.ListTeamPageContentQuery>;
export const listTestimonials = /* GraphQL */ `query ListTestimonials {
  listTestimonials {
    announcement_id
    announcement_name
    created_at
    is_active
    original_text
    summary
    testimonial_id
    testimonial_sequence
    updated_at
    users {
      badge_color
      business_title
      cost_center_name
      employee_status
      first_name
      job_status
      last_name
      legacy_employee_id
      login
      person_id
    }
  }
}
` as GeneratedQuery<APITypes.ListTestimonialsQueryVariables, APITypes.ListTestimonialsQuery>;
export const listTicketMetricDetail = /* GraphQL */ `query ListTicketMetricDetail {
  listTicketMetricDetail {
    ticket_details {
      data {
        application_name
        assigned_date
        assigned_to_group
        assigned_to_individual_name
        assignee_login
        case_id
        create_date
        impact
        last_modified_by
        manager_login_hierarchy_concat
        manager_name_hierarchy_concat
        modified_date
        resolution_type
        resolved_date
        short_description
        sim_issue_alias
        status
        team_name
        total_time_spent
      }
      metadata {
        last_updated_at
      }
    }
  }
}
` as GeneratedQuery<APITypes.ListTicketMetricDetailQueryVariables, APITypes.ListTicketMetricDetailQuery>;
export const listUserMetric = /* GraphQL */ `query ListUserMetric {
  listUserMetric {
    user_metrics_details {
      data {
        application
        application_type
        display_sub_application_name
        distinct_users
        last_updated_at
        log_month
        measure_value
        supervisor_login_name_hierarchy
        supervisor_name_hierarchy
        team_name
      }
      metadata {
        last_updated_at
      }
    }
  }
}
` as GeneratedQuery<APITypes.ListUserMetricQueryVariables, APITypes.ListUserMetricQuery>;
export const getQuickSightEmbedUrl = /* GraphQL */ `query GetQuickSightEmbedUrl($dashboardId: String!) {
  getQuickSightEmbedUrl(dashboardId: $dashboardId)
}
` as GeneratedQuery<APITypes.GetQuickSightEmbedUrlQueryVariables, APITypes.GetQuickSightEmbedUrlQuery>;

export const listMcpConfigs = /* GraphQL */ `query ListMcpConfigs {
  listMcpConfigs {
    id
    name
    description
    category
    logoConfig {
      logoType
      s3Location {
        bucket
        contentType
        key
        region
      }
      selectedLogoName
      uploadedFileName
    }
    terminalCommands {
      os
      method
      command
    }
    resources {
      label
      url
      type
    }
    toolGroups {
      category
      tools {
        name
        description
      }
    }
    features {
      icon
      title
      description
    }
    contacts {
      alias
      role
    }
    isFeatured
    createdAt
    updatedAt
    createdBy
    updatedBy
  }
}
` as GeneratedQuery<any, any>;
export const getMcpConfig = /* GraphQL */ `query GetMcpConfig($id: String!) {
  getMcpConfig(id: $id) {
    id
    name
    description
    category
    logoConfig {
      logoType
      s3Location {
        bucket
        contentType
        key
        region
      }
      selectedLogoName
      uploadedFileName
    }
    terminalCommands {
      os
      method
      command
    }
    resources {
      label
      url
      type
    }
    toolGroups {
      category
      tools {
        name
        description
      }
    }
    features {
      icon
      title
      description
    }
    contacts {
      alias
      role
    }
    isFeatured
    createdAt
    updatedAt
    createdBy
    updatedBy
  }
}
` as GeneratedQuery<any, any>;
